module.exports = __webpack_public_path__ + "static/media/Coronary_Angiography_186128HD.259995f5.mp4";